
import axios from 'axios';
import Api from '../api/ApiUrl'

const API_URL = `${Api}/api/v1/splash`;
const config = {
  headers: {
      // Authorization: `Bearer ${Cookies.get('token')}`,
      role: 'admin'
  },
};
const SplashService = {
  getAll: () => {
    return axios.get(API_URL,config);
  },

  get: (id) => {
    return axios.get(`${API_URL}/${id}`);
  },

  create: (data) => {
    const formData = new FormData();
    formData.append('name', data.name);
    formData.append('description', data.description);
    formData.append('coverphoto', data.coverphoto);

    return axios.post(API_URL, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        role: 'admin'

      },
    });
  },

  update: (id, data) => {
    const formData = new FormData();
    formData.append('name', data.name);
    formData.append('description', data.description);
    if (data.coverphoto) {
      formData.append('coverphoto', data.coverphoto);
    }

    return axios.patch(`${API_URL}/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        role: 'admin'

      },
    });
  },

  remove: (id) => {
    return axios.delete(`${API_URL}/${id}`,config);
  },
};

export default SplashService;
